import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setDeviceError } from '../../reducer/onBoardSlice';

const ErrorRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const pathnameRef = useRef(location.pathname);
  const redirectedRef = useRef(false);

  useEffect(() => {
    pathnameRef.current = location.pathname;
    if (location.pathname.startsWith('/onboarding')) {
      redirectedRef.current = false;
    }
  }, [location.pathname]);

  useEffect(() => {
    const handleDeviceError = (event) => {
      if (!pathnameRef.current.startsWith('/onboarding')) return;
      if (redirectedRef.current) return;
      redirectedRef.current = true;
      const message = event.detail?.message || 'An unexpected device error occurred.';
      dispatch(setDeviceError(message));
      navigate('/error');
    };

    window.addEventListener('device-error', handleDeviceError);
    return () => window.removeEventListener('device-error', handleDeviceError);
  }, [navigate, dispatch]);

  return null;
};

export default ErrorRedirect;